import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task06 } from "../../../../../task/course-02/lesson-12/task-06";

const task: Slide = {
  titleHtml:
    "Which of the following sound source location pairs fall<br>in a cone of confusion region or is generally difficult to localize?",
  description: "Select the correct answer(s).",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/12/task/task-6.svg`,
                },
              },
              styles: {
                padding: "2%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task06.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
